import React from 'react'


const Footer = (props) => (
    <footer id="footer">
        <div className="inner">
            <ul className="icons">
                <li><a href="https://www.facebook.com/guelkebappizzahaus" className="icon alt fa-facebook"><span className="label">Facebook</span></a></li>
                <li><a href="https://www.instagram.com/guelkebappizzahaus/" className="icon alt fa-instagram"><span className="label">Instagram</span></a></li>
            </ul>
            <ul className="copyright">
                <li>&copy;Gül Kebap und Pizza Haus Lambrecht(Pfalz) </li><li>Design & Development: <a href="https://www.onlinefoodorapp.com">https://www.onlinefoodorapp.com/</a></li>
            </ul>
            <nav id="footer-menu">
                <ul className="links">
                    <li><a onClick={props.onToggleMenu} href="/imprint">Impressum</a></li>
                    <li><a onClick={props.onToggleMenu} href="/privacy">Datenschutz</a></li>
                </ul>
            </nav>
        </div>
    </footer>
)

export default Footer
